import React from 'react';
import { FlaskConical } from 'lucide-react';

import { Alert } from '../../shared/ui';

export function DemoBanner({ section }: { section: string }) {
  return (
    <Alert className="mb-5" icon={<FlaskConical size={16} />}>
      <span className="font-medium">Раздел «{section}» в разработке.</span> Данные и интерфейс ниже — это пример того,
      как будет выглядеть раздел после запуска. Функциональность станет доступна в ближайшее время. 🚧
    </Alert>
  );
}
